import * as React from 'react'
import InputWrapper from '@App/components/controls/InputWrapper'
// @ts-ignore
import Input from '@App/components/blocks/Input'

const InputField = (props: any) => {
  const {
    className,
    meta,
    input,
  } = props

  return (
    <InputWrapper meta={meta} {...props}>
      <Input
        className={className}
        valid={!(meta.touched && meta.error)}
        {...props}
        {...input}
      />
    </InputWrapper>
  )
}

export default InputField
